import { isHex } from './isHex.js';
export function size(value) {
    if (isHex(value))
        return Math.ceil((value.length - 2) / 2);
    return value.length;
}
//# sourceMappingURL=size.js.map